import React from "react";

import ExchangeMD from "@busbud/design-system-components/dist/Icons/Exchange/MD";
import WarningMD from "@busbud/design-system-components/dist/Icons/Warning/MD";
import Label from "@busbud/design-system-components/dist/Label";
import Stack from "@busbud/design-system-components/dist/Stack";

import { getFormattedDuration } from "@app/helpers/duration";
import { useAppContext } from "@app/helpers/hooks";

import { useStyles } from "./transfer-message.styles";
import { CheckpointLayout } from "../checkpoint-layout";
import { CheckpointPath } from "../checkpoint-path";

interface Props {
  duration: any;
  title: string;
  type?: "transfer" | "change";
}

export const TransferMessage: React.FC<Props> = ({
  duration,
  title,
  type = "transfer"
}) => {
  const { translator } = useAppContext();
  const { cx, classes } = useStyles();
  const Icon = type === "transfer" ? ExchangeMD : WarningMD;

  return (
    <>
      <CheckpointLayout
        class_name={cx(classes.container, {
          [classes.severityNotice]: type === "transfer",
          [classes.severityNegative]: type === "change"
        })}
        has_indent={false}
        slot_start={
          <div className={classes.icon}>
            <Icon />
          </div>
        }
        slot_middle={
          <CheckpointPath
            class_name={classes.checkpointPath}
            has_icon={false}
            line_color="border.notice.transparent"
            line_variant="dashed"
          />
        }
        slot_end={
          <Stack className={classes.content} direction="column" spacing={0.5}>
            <Label fontWeight="bold" size="xs">
              {title}
            </Label>
            <Label
              component="time"
              // @ts-expect-error
              dateTime={String(duration)}
            >
              {getFormattedDuration(duration, translator)}
            </Label>
          </Stack>
        }
      />
      <CheckpointLayout
        class_name={classes.indent}
        slot_middle={<CheckpointPath has_icon={false} />}
      />
    </>
  );
};
